
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.003 8.773a6.562 6.562 0 00-4.422-1.97 6.038 6.038 0 01-.014-.447c0-.81.616-3.282 1.004-4.65l.397-1.401h-4.819l-.323.52c-.128.206-3.136 5.138-3.136 12.573A6.61 6.61 0 0022.292 20a6.61 6.61 0 006.602-6.602c0-1.74-.672-3.383-1.891-4.625zm-4.71 9.026a4.406 4.406 0 01-4.402-4.4c0-5.465 1.806-9.51 2.52-10.894h.667c-.316 1.243-.712 2.973-.712 3.851 0 .697.052 1.257.305 1.724.225.416.695.912 1.66.917l.048.001c2.379.046 4.314 2.02 4.314 4.4a4.406 4.406 0 01-4.4 4.401zM12.039 8.773a6.561 6.561 0 00-4.422-1.97 6.026 6.026 0 01-.014-.447c0-.81.616-3.282 1.004-4.65L9.004.304H4.185l-.323.52C3.734 1.03.726 5.963.726 13.398A6.61 6.61 0 007.328 20a6.61 6.61 0 006.602-6.602c0-1.74-.672-3.383-1.891-4.625zM7.328 17.8a4.406 4.406 0 01-4.401-4.4c0-5.465 1.806-9.51 2.52-10.894h.667c-.316 1.243-.711 2.973-.711 3.851 0 .697.051 1.257.304 1.724.225.416.695.912 1.66.917l.048.001c2.379.046 4.314 2.02 4.314 4.4A4.406 4.406 0 017.328 17.8z"}})])
          )
        }
      }
    